import Canvas from './canvas'

export default Canvas
